export const PRODUCTS = {
  MAINAPP: 'MAINAPP',
  CHECKPOINT: 'CHECKPOINT',
  POLICIES: 'POLICIES',
  AUTO_AUTH: 'AUTO',
};
export const PACKAGES = {
  PA_ROUTING: 'routing',
};
export const ACCESSLEVEL = {
  LIMITED: 'limited',
  FULL: 'full',
};
export const ROLES = {
  // tenantAdminOrgsRole: 'ROLES#a057554e-777f-44f9-beb6-dfd0d9deaf26',
  // platformOperator: 'platform operator',
  // platformAdminTitle: 'platform administrator',
  tenantAdminTitle: 'tenant administrator',
  // tenantManagerTitle: 'tenant manager',
  // tenantUser: 'tenant user',
  // policyUser: 'policy user',
  // policyOperator: 'policy operator',
  // policyManager: 'policy manager',
  // tenantOperator: 'tenant operator',
  // tenantAnalyst: 'tenant analyst',
  PLATFORM_ADMIN: 'platform_admin',
  PLATFORM_OPERATOR: 'platform operator',
  TENANT_ADMIN: 'tenant_admin',
  PACHECK_ADMIN: 'checkpoint_admin',
  PACHECK_operator: 'checkpoint_operator',
  PACHECK_USER: 'checkpoint_user',
  POLICY_ADMIN: 'policies_admin',
  POLICY_OPERATOR: 'policies_operator',
  POLICY_USER: 'policies_user',
  AUTO_ADMIN: 'auto_admin',
  AUTO_OPERATOR: 'auto_operator',
  AUTO_USER: 'auto_user',
};
export const hasMainAppSettingsMenuAccess = [
  ROLES.TENANT_ADMIN,
];
export const hasCheckpointSettingsMenuAccess = [
  ROLES.tenantAdminTitle,
  ROLES.TENANT_ADMIN,
  ROLES.PACHECK_ADMIN,
];
export const hasPolicySettingsMenuAccess = [
  ROLES.tenantAdminTitle,
  ROLES.TENANT_ADMIN,
  ROLES.POLICY_ADMIN,
];
export const hasAutoAuthSettingsMenuAccess = [
  ROLES.tenantAdminTitle,
  ROLES.TENANT_ADMIN,
  ROLES.AUTO_ADMIN,
];
export const GLOBAL_ENITY = {
  organization:'organization'
}
export const globalDateEntity = {
  siteHeaderTitle: 'itiliti Health',
  footerText: 'Copyright 2023 Itiliti Health. All Rights Reserved',
  primaryColor: '#42b883',
  primaryFontColor: '#ffffff',
  primaryFontFamily: 'Alatsi, sans-serif',
  secondaryFontFamily: 'Abel, sans-serif',
  backgroundColor: '#ffffff',
  dateFormatPost: 'YYYY-MM-DD',
  dateTimeFormatPost: 'YYYY-MM-DDT00:00:00',
  brandingLogoSize: 3145728,
  dateFormat: 'MM-DD-YYYY',
  dateTimeFormat: 'MM-DD-YYYY h:mm:ss',
  datePickerFormat: 'MM-DD-YYYY',
  timePostfix: 'T00:00:00',
  dateTimeFormatWith24Hour: 'MM-DD-YYYY HH:mm:ss',
  defaultTimezone: 'cst',
  displayDateFormat1: 'MMM DD, YYYY',
};
export const MESSAGE = {
  httpURL: 'http',
  httpsURL: 'https',
  logoSizeText: '3MB',
  logoTypeText: 'JPEG, PNG, JPG',
  addedRecordMsg: 'Record added!',
  recordAdditionFailedMsg: 'Record not added!',
  updateMsg: 'Record updated!',
  recordUpdationFailedMsg: 'Record not updated!',
  addedAssociationMsg: 'Association added!',
  recordAssosiationFailedMsg: 'Association not added!',
  cloneAssociationMsg: 'Record cloned!',
  recordCloningFailedMsg: 'Record no cloned!',
  dltAssociationMsg: 'Record deleted!',
  recordDeletionFailedMsg: 'Record not deleted!',
  inactiveAssociationMsg: 'Record disabled!',
  recordInactivationFailedMsg: 'Record not deactivated!',
  digitsValidationMsg: 'Field requires numeric values',
  threeDigitsValidationMsg: 'Must be exactly 3 digits',
  requiredValidationMsg: 'Field is required',
  requiredReviewDateGreaterMsg:
    'Review date should be greater than effective date',
  inactiveDatePriorValid:
    'End date should be between old effective date and new effective date',
  specialCharValidationMsg: 'does not support special characters',
  phoneValidationMsg: 'Phone number not valid',
  validEmailMsg: 'Email address not valid',
  userCharLimitValidMsg: 'User name must be at least 4 characters',
  userMaxCharLimitValidMsg: 'User name can not be more than 70 characters',
  urlValidMsg: 'Url not valid',
  faxNumberValidMsg: 'Fax number not valid',
  noRecordFound: 'No records found',
  passwordChangedMsg: 'Password updated, redirecting to login page', //NOSONAR
  passwordResetMsg: 'Password updated, redirecting to login page', //NOSONAR
  passwordMinCharValidationMsg: 'Password must be at least 8 characters', //NOSONAR
  passwordMatchMsg: 'Passwords do not match', //NOSONAR
  hundredCharLimitValidatioMsg: 'Description limited to 100 characters',
  versionPriorValidationMsg:
    'New effective date must be greater that prior date',
  versionPriorUpdateValidationMsg:
    'Date should be between old version effective date and new version effective date',
  deactiveEnityDatePriorValidationMsg:
    'Date should be greater than effective date',
  duplicateProcedureErrMsg: 'Duplicate procedure codes are not allowed',
  groupLOBValidationErrMsg:
    'Group cannot be associated with multiple business lines',
  unsavedFormLeaveHead: 'Confirm Navigation',
  unsavedFormLeave: 'Changes you made may not be saved. Do you want to leave this page?',
  importJobProcessingRedirectMsg:
    'Import job is processing, redirecting to Import list',
  importJobProcessingMsg: 'Import Job is being processed',
  fileUploadSuccessMsg: 'File uploaded',
  fileUploadFailureMsg: 'File not uploaded',
  fileUploadTypeErrorMsg: 'Please check the file you are trying to upload',
  fileDeleteFailureMsg: 'File(s) not deleted',
  fileDeleteMsg: 'File(s) deleted',
  uploadFileValidationErrMsg: 'Please upload this file to the server',
  fileDownloadFailureMsg: 'File not downloaded',
  brandingLogoType: 'File must be with .jpeg, .jpg, .png',
  brandingLogoSize: 'File must be less then 3MB',
  groupValidMsg: 'Group is valid',
  primaryLookupMsg: 'Primary lookup id is valid',
  validMemberNumber: 'Member number is valid',
  validGroupNumber: 'Member group number is valid',
  dupAssoNotificationHeading:
    'Warning: Association already exists for this record',
  verificationCodeMsg: 'Verification code has been sent to your e-mail address',
  reasonLimitValidationMsg: 'Reason can not be more than 256 characters',
  tenthCharLimitValidMsg: 'can not be more than 10 characters',
  fifteenCharLimitValidMsg: 'can not be more than 15 characters',
  twentyCharLimitValidMsg: 'can not be more than 20 characters',
  thirtyCharLimitValidMsg: 'can not be more than 30 characters',
  fiftyCharLimitValidMsg: 'can not be more than 50 characters',
  seventyCharLimitValidMsg: 'can not be more than 70 characters',
  hundredCharLimitValidMsg: 'can not be more than 100 characters',
  twoHundredCharLimitValidMsg: 'can not be more than 200 characters',
  fiveHundredCharLimitValidMsg: 'can not be more than 500 characters',
  overLapAssoMsg:
    'There is an overlap in the dates selected for current version and previous versions',
  openEndDateAssoMsg:
    'Open End Dates of all the versions can not be greater than 1',
  CanNotMoreThan: 'can not be more than {NUMBER} characters',
  NetWorkError: 'Oops something went wrong. please try again',
  DownloadNotAvailable: 'Not Available for download',
  DownloadAvailable: 'Available for download',
  LoadingText: 'Please wait, data is being loaded...',
  inactiveDateError: 'End date must be greater than effective date',
  invalidDate: 'Invalid date format',
  minDate: 'Date must be later than 01-01-2000',
  uploadLimit5MBError: 'The file exceeds the 5 MB upload limit',
  effectiveDateNeededBeforeEndDate: 'Please select effective date first',
  addEffectiveDateFirst:
    'Please add Effective Date first for the selected record(s)',
  oneOrMoreEffectiveDateInvalidated:
    'End Date should be greater than the Effective Date for the selected record(s)',
  UNSAVED_ADD_POLICY_FORM: 'Changes are not saved, do you want to skip adding policy ?',
  UNSAVED_EDIT_POLICY_FORM: 'Changes are not saved, do you want to skip updating policy ?',
  UNSAVED_CLONE_POLICY_FORM: 'Changes are not saved, do you want to skip cloning policy ?',
  DIALOG_TEXT_POLICY_SAVED_BODY: 'Changes successfully saved!',
  DIALOG_TEXT_POLICY_SAVED_BTN_CONTINUE: 'Continue Editing',
  DIALOG_TEXT_POLICY_SAVED_BTN_RETURN: 'Return to Policy Listing',
  SAVED:"Successfully saved",
  UPDATED:"Successfully updated",
  FAILED:"Failed to save",
  DELETED:"Successfully deleted",
  ERORR_UPDATING_PREV_VERSION_DATE: "Error updating previous version end date. ",
  POLICY_INACTIVE_BANNER: "This policy is inactive ",
  POLICY_MODULE_ACCESS_FORBIDDEN: "Policy module access is forbidden",
  IDLE_ALERT_POPUP_TITLE: "Session Timeout Warning",
  IDLE_ALERT_POPUP_BODY: "The session expires in %time_left%. Click OK to Continue or CANCEL to close the session.",
  DEFAULT_PACKAGE_DELETE_MSG: "Default package cannot be removed",
  overLapEffectiveDateAssoMsg: "Effective Date Overlaps with Existing Association",
  overLapEndDateAssoMsg: "End Date Overlaps with Existing Association",
  gapDateAssoMsg: "Warning: There is a gap between the current version and the previous version, if you want continue please submit",
  overLapEffectiveDateRuleSetMsg: "Effective Date Overlaps with Existing Rule Set",
  overLapEndDateRuleSetMsg: "End Date Overlaps with Existing Rule Set",

  // Common validation error msgs
  VALIDATION: {
    REQUIRED: '{name} is required',
    MINCHAR: '{name} should not less then {limit} characters',
    MAXCHAR: '{name} should not greater then {limit} characters',
    MINMAXCHAR: '{name} should between {minlimit} to {maxlimit} characters',
  },
};
